module.exports = __webpack_public_path__ + "static/q9-f9a122bfcb62932d4c9990a528c32962.png";